import { render, staticRenderFns } from "./statisticalReportCO.vue?vue&type=template&id=12d8cdd8&scoped=true"
import script from "./statisticalReportCO.vue?vue&type=script&lang=js"
export * from "./statisticalReportCO.vue?vue&type=script&lang=js"
import style0 from "./statisticalReportCO.vue?vue&type=style&index=0&id=12d8cdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8cdd8",
  null
  
)

export default component.exports